import * as React from 'react';
import { QuestionnaireFieldOptionListLocalDto } from '@modules/fhq-design-tool/dto/field-option';

export type DropdownOptionsProps = {
  disabled?: boolean;
  className?: string;
  data: Array<QuestionnaireFieldOptionListLocalDto>;
  onChange: (data: Array<QuestionnaireFieldOptionListLocalDto>) => void;
};

export const useDropdownOptionsController = (props: DropdownOptionsProps) => {
  const { data, onChange } = props;
  const [selectOptionId, setSelectedOptionId] = React.useState<string | undefined>(undefined);

  const handleDisplayChange = React.useCallback((val: boolean, e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(data.map((x) => x.id === e.currentTarget.dataset.id ? ({ ...x, displayInFHQ: val }) : x));
  }, [data, onChange]);

  const handleDropdownValueChange = React.useCallback((option: QuestionnaireFieldOptionListLocalDto, val: string) => {
    onChange(data.map((x) => x.id === option.id ? ({ ...x, dropdownValue: val }) : x));
  }, [data, onChange]);

  const handleRowClick = React.useCallback((e: React.MouseEvent<HTMLDivElement>) => {
    setSelectedOptionId((e.currentTarget as unknown as { dataset: { id: string } }).dataset.id);
  }, []);

  return {
    handleRowClick,
    selectOptionId,
    handleDropdownValueChange,
    handleDisplayChange,
  };
};